import Page from "@/components/pages/inventory/purchase-order/page";
import { createFileRoute } from "@tanstack/react-router";
// import { withRouteProtection } from "@/lib/router/route-protection";
// import { createProtection } from "@/lib/router/protection-presets";

export const Route = createFileRoute("/_app/inventory/purchase-order/")({
	component: Page,
	// ...withRouteProtection(createProtection.editorOrHigher()),
});
